import { TIMEFRAMES, type Timeframe } from "@/lib/types";
import { cn } from "@/lib/utils";

const LABELS: Record<Timeframe, string> = {
  today: "Idag",
  week: "Vecka",
  month: "Månad",
  "3mo": "3 mån",
  "6mo": "6 mån",
  "12mo": "12 mån",
  all: "Allt",
};

export function TimeframeTabs({ value, onChange }: { value: Timeframe; onChange: (tf: Timeframe) => void }) {
  return (
    <div className="inline-flex flex-wrap gap-1 rounded-lg bg-muted p-1">
      {TIMEFRAMES.map((tf) => (
        <button
          key={tf}
          onClick={() => onChange(tf)}
          className={cn(
            "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
            value === tf ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground",
          )}
        >
          {LABELS[tf]}
        </button>
      ))}
    </div>
  );
}
